import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { CONSTANCIA } from './Styles/Styles';
import logo from "../../assets/img/logo_menu_black.png";

class ConstanciaEst extends Component {
    state = {  }
    render() {
        let DatPersonales = this.props.datos.datosPersonales;
        let Carrera = this.props.datos.carrera;
        let Materias = this.props.datos.materias;
        let autData = this.props.datos.director;
        let ctrolData = this.props.datos.ctrEstudios;

        const styles = StyleSheet.create(CONSTANCIA[0]);
        let nombre2 = "";
        let apellido2 = "";
        (DatPersonales.nombre_2 === null) ? nombre2 = "" : nombre2 = DatPersonales.nombre_2;
        (DatPersonales.apellido_2 === null) ? apellido2 = "" : apellido2 = DatPersonales.apellido_2;

        let Estudiante = `${DatPersonales.nombre_1} ${nombre2} ${DatPersonales.apellido_1} ${apellido2}`;
        let Cedula = `${DatPersonales.nacionalidad} ${DatPersonales.ci}`;

        let tipoMod = (tipo) => {
            switch (parseInt(tipo)) {
                case 1:
                    return 'PRESENCIAL';
                case 2:
                    return 'PRUEBA DE SUFICIENCIA' ;
                case 2:
                    return 'VERANO' ;
                default:
                    return 'PRESENCIAL';
            }
        }

        let fecha = () => {
            let fehaEnt = this.props.fecha;
            let fechaPartes = fehaEnt.split("/")
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            return `${fechaPartes[0]} días del mes de ${meses[parseInt(fechaPartes[1]) - 1]} de ${fechaPartes[2]}`
        }

        let materiasIns = () => {
            if (Materias.length === 0) return (
                <Text style={{marginTop: 10, fontSize: 12,}}>
                    El estudiante no posee ninguna materia inscrita
                </Text>
            )
            return(
                <React.Fragment>
                    <View style={[styles.row, styles.customRow]}>
                        <Text style={[styles.column, styles.Ecol1]}>Código</Text>
                        <Text style={[styles.column, styles.Ecol2]}>Materia</Text>
                        <Text style={[styles.column, styles.Ecol3]}>Semestre</Text>
                        <Text style={[styles.column, styles.Ecol4]}>Modalidad</Text>
                    </View>

                    {Materias.map(option => (
                        <View style={[styles.row, styles.customRow]} key ={option.codigo}>
                            <Text style={[styles.column, styles.col1, {borderLeft: 0.5, padding:4}]}>{option.codigo}</Text>
                            <Text style={[styles.column, styles.col2, {borderLeft: 0.5, padding:4}]}>{option.materia_name}</Text>
                            <Text style={[styles.column, styles.col3, {borderLeft: 0.5, padding:4}]}>{option.semestre_name}</Text>
                            <Text style={[styles.column, styles.col4, {borderLeft: 0.5, borderRight: 0.5, padding:4}]}>{tipoMod(option.tipo_curso)}</Text>
                        </View>
                    ))}
                </React.Fragment>
                
            )
        }

        let nombreAut = (tipo) => {
            if (tipo === 1) return `${autData.aut_name} ${autData.aut_ape}`;
            return `${ctrolData.aut_name} ${ctrolData.aut_ape}`;
        }

        let ciAut = (tipo) => {
            if (tipo === 1) return autData.cedula;
            return ctrolData.cedula; 
        }

        let tipoFirmante = (tipo) => {
            if (tipo === 1) return "DIRECTORA"
            if (tipo === 0) return "JEFE CONTROL DE ESTUDIOS"
        }
        
        return (
            <PDFViewer style={styles.section}>
                <Document title="Constancia de Estudios">
                    <Page size="letter" style={styles.body}>
                        <View>
                            <Image style={[styles.logo, {marginBottom: 30}]} src={logo} />
                            {/* <Text style={[styles.encabezado, {marginTop: 10}]}>REPÚBLICA BOLIVARIANA DE VENEZUELA</Text> */}
                            {/* <Text style={styles.encabezado}>MINISTERIO  DEL  PODER  POPULAR  PARA  LA  EDUCACIÓN  UNIVERSITARIA</Text> */}
                            <Text style={styles.encabezado2}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={styles.encabezado5}>M.E. Nº 130 G.O. Nº 36.719  9 JUNIO 1.999</Text>
                            {/* <Text style={[styles.encabezado3, {marginTop: -5}]}>RIF.J-30583313-3</Text> */}

                            <Text style={[styles.encabezado2, {marginTop: 20}]}>CONSTANCIA DE ESTUDIOS</Text>

                            <Text style={[styles.parrafo, {marginTop: 20}]}>
                                Quien suscribe, {nombreAut(0)}, titular de la Cédula de Identidad V-{ciAut(0)} {tipoFirmante(0)} del Instituto Universitario De Diseño Las Mercedes,   hace constar  que el (la) ciudadano (a):
                            </Text>
                            <Text style={[styles.nombre, {marginTop: 10}]}>
                                {Estudiante}
                            </Text>
                            <Text style={[styles.parrafo, {marginTop: 10}]}>
                                Titular de la Cédula de Identidad {Cedula}, está inscrito en {Carrera}. Área de Conocimiento, Ciencia y Tecnología.
                            </Text>

                            <View style={[styles.bordeConstancia, {padding: 5, marginTop: 5, backgroundColor: "#FFF"}]}>
                                <Text style={{padding: 2, fontSize: 10, backgroundColor: "#ccc"}}>
                                    MATERIAS INSCRITAS
                                </Text>
                                <View style={[styles.encabezado, {marginTop: 5, marginLeft: 10,}]}>
                                    {materiasIns()}
                                </View>
                            </View>
                        
                            <Text style={[styles.parrafo, {marginTop: 10}]}>
                                Constancia que se expide a solicitud de la parte interesada, en Caracas, a los {fecha()}.
                            </Text>

                            <Text style={[styles.firma, {marginTop: 60}]}> {nombreAut(0)} </Text>
                            <Text style={[styles.firma, {marginTop: -5}]}> {tipoFirmante(0)} </Text>
                            <View style={[styles.footer3]}>
                                <View style={[styles.row]}>
                                    <View style={[styles.col11]}>
                                        {/* <Text style={[styles.encabezado, {fontSize: 6, textAlign: "center"}]}>
                                            Esta planilla debe ser impresa en Papel Bond Blanco tamaño Carta | Para autenticar esta constancia valla al enlace: https://iudlm.com/validar?code={this.props.token}. También puede escanear el código qr de la derecha.
                                        </Text> */}
                                        <Text style={[styles.linea3]}></Text>
                                        <Text style={[styles.encabezado, {fontSize: 7}]}>
                                            Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                            C.P.1061  Edo Miranda - Caracas - Venezuela
                                        </Text>
                                        <Text style={[styles.encabezado, {marginTop: -5, fontSize: 7}]}>
                                            Telefax: +58 212 9930983 | 9939139 | 9910710.
                                        </Text>
                                    </View>
                                    {/* <View style={[styles.col10]}>{console.log(this.props.qr)}
                                        <Image
                                            style={[styles.logoQr, {left:20}]}
                                            src={this.props.qr}
                                        />
                                    </View> */}
                                </View>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default ConstanciaEst;


// WEBPACK FOOTER //
// ./src/components/Reportes/ConstanciaEst.jsx